module.exports = __webpack_public_path__ + "static/media/icon-building-white.01f4148a.svg";